/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.NoBoxCRM {
    import fld = FormresultsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class FormresultsGrid extends NoboxEntityGrid<FormresultsRow, any> {
        protected getColumnsKey() { return FormresultsColumns.columnsKey; }
        protected getDialogType() { return FormresultsDialog; }
        protected getIdProperty() { return FormresultsRow.idProperty; }
        protected getInsertPermission() { return FormresultsRow.insertPermission; }
        protected getLocalTextPrefix() { return FormresultsRow.localTextPrefix; }
        protected getService() { return FormresultsService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            var q = Q.parseQueryString();
            if (q["paid"]) {
                var isPaid = this.findQuickFilter(FormStatusPaymentEditor,
                    FormresultsRow.Fields.IsPaid)
                isPaid.value = q["paid"];
            }
            if (q["st"]) {
                var Status = this.findQuickFilter(FormStatusEditor,
                    FormresultsRow.Fields.St)
                Status.value = q["st"];
            }
            if (q["sd"] && q["ed"]) {
                var categoryCr = this.findQuickFilter(CustomDateFilter,
                    FormresultsRow.Fields.DateIn);
                if (q["sd"] == "All" || q["ed"] == "All") {
                    categoryCr.set_value(null);
                    categoryCr.end_set_value(null);
                } else {
                    categoryCr.set_value(q["sd"]);
                    categoryCr.end_set_value(q["ed"]);
                }
            }
            if (q["form"]) {
                var Form = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    FormresultsRow.Fields.FormId)
                Form.value = q["form"];
            }

        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            
            console.log(flt,"asdfsaf")
            var filter2 = Q.first(flt, x => x.field == FormresultsRow.Fields.TagIds);
            filter2.handler = h => {
                const request = (h.request as FormresultsListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    h.handled = true;
                } else {
                    request.Tags = [];
                    h.handled = true;
                }
            };

            var filter3 = Q.first(flt, x => x.field == FormresultsRow.Fields.DateIn);
            filter3.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["DateIn"], ">=", start], "and", [["DateIn"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["DateIn"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["DateIn"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    h.handled = true;
                }
            };

            return flt;
        }


        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            return true;
        }
        getFormStatusText(status: FormStatusEnum): string {
            switch (status) {
                case FormStatusEnum.Pending:
                    return 'Pending';
                case FormStatusEnum.Process:
                    return 'Process';
                case FormStatusEnum.Complete:
                    return 'Complete';
                case FormStatusEnum.Refund:
                    return 'Refund';
                case FormStatusEnum.Cancel:
                    return 'Cancel';
                default:
                    return 'Pending';
            }
        }
        getFormPaymentStatusText(status: FormStatusPaymentEnum): string {
            switch (status) {
                case FormStatusPaymentEnum.Unpaid:
                    return 'Unpaid';
                case FormStatusPaymentEnum.Paid:
                    return 'Paid';
                default:
                    return '';
            }
        }
        getColumns() {
            var column = super.getColumns();
            column.unshift({
                field: "FollowUp",
                cssClass: "followup text-center",
                width: 60,
                name: "",
                format: (ctx) => {
                    return `<button class="lkbtn btn-followup"><i class="fa fa-comment btn-followup"></i></button>`;
                }
            });

            Q.first(column, x => x.field == fld.Form).format =
                ctx => `<a href="javascript:;" class="form-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(column, x => x.field == fld.St).format =
                ctx => `<a href="javascript:;" class="status-link">${Q.htmlEncode(this.getFormStatusText(ctx.value))}</a>`;
            Q.first(column, x => x.field == fld.IsPaid).format =
                ctx => `<a href="javascript:;" class="paid-link">${Q.htmlEncode(this.getFormPaymentStatusText(ctx.value))}</a>`;
            return column;
        }
        onClick(e, row, cell) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented()) {
                return;
            }

            var item = this.itemAt(row);
            var target = $(e.target);
            if (target.hasClass("btn-followup")) {
                var dlg = new FormFollowUpDialog();
                dlg.formResultEntity = item;
                dlg.loadByIdAndOpenDialog(item.Id);
            } else if (target.hasClass("form-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by form");
                var formFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    FormresultsRow.Fields.FormId);
                formFilter.set_value(item.FormId.toString());
                this.refresh();
            } else if (target.hasClass("status-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by status");
                var stFilter = this.findQuickFilter(FormStatusEditor,
                    FormresultsRow.Fields.St);
                stFilter.set_value(Q.isEmptyOrNull(item.St.toString()) ? "0" : item.St.toString());
                this.refresh();
            } else if (target.hasClass("paid-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by paid");
                var paidFilter = this.findQuickFilter(FormStatusPaymentEditor,
                    FormresultsRow.Fields.IsPaid);
                paidFilter.set_value(item.IsPaid.toString());
                this.refresh();
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    FormresultsRow.Fields.TagIds);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            }
        }
    }
}